// The crew-list daily badge's "today" rule, extracted from Vendors.tsx so it
// can be tested without mounting the DataTable — same idiom as
// partner-products-state.ts's nextProductState.
//
// This mirrors the API's own rule exactly (prices_confirmed_at::date =
// CURRENT_DATE in apps/api/src/modules/vendor/fixed-price.ts): a UTC
// calendar-day comparison, not "within the last 24h". Doing it any other
// way would show ops a different badge than the crew app shows the crew
// filling in the same opt-in.

import type { AdminVendorRow } from '@/lib/admin-api';

export type FixedPriceBadge = 'prices_confirmed' | 'prices_stale' | null;

function utcDateString(iso: string): string {
  return new Date(iso).toISOString().slice(0, 10);
}

/**
 * Not opted in → no pill at all (null): the badge exists to tell ops
 * whether a fixed-mode-eligible crew's prices are current, and that
 * question doesn't apply to a crew that never opted in.
 *
 * Opted in → 'prices_confirmed' if `pricesConfirmedAt` falls on today's UTC
 * calendar day, else 'prices_stale' (including never confirmed at all).
 */
export function fixedPriceBadge(
  vendor: Pick<AdminVendorRow, 'fixedPriceOptin' | 'pricesConfirmedAt'>,
  now: Date = new Date(),
): FixedPriceBadge {
  if (!vendor.fixedPriceOptin) return null;
  if (!vendor.pricesConfirmedAt) return 'prices_stale';
  return utcDateString(vendor.pricesConfirmedAt) === utcDateString(now.toISOString())
    ? 'prices_confirmed'
    : 'prices_stale';
}
